import Box from '@mui/material/Box'
import * as React from 'react'
import FloatingBar from './FloatingBar/FloatingBar'

type Props = {
  newLayout?: boolean
  color?: string
  children: JSX.Element
}

function Layout({ color, children, newLayout = false }: Props) {
  const [isLg, setIsLg] = React.useState(window.innerWidth >= 600)
  const navbarHeight = isLg ? 64 : 56

  React.useEffect(() => {
    const handleResize = () => {
      setIsLg(window.innerWidth >= 600)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  if (newLayout) {
    return (
      <Box display="flex" flexDirection="column" height="100dvh" gap={0.5}>
        <FloatingBar />
        <Box
          flex={1}
          display="flex"
          flexDirection="column"
          width="100dvw"
          overflow="scroll"
          mt={`${navbarHeight}px`}
          sx={{ backgroundColor: color ? color : 'white' }}
        >
          {children}
        </Box>
      </Box>
    )
  } else {
    return (
      <div>
        <FloatingBar />
        <Box
          display="flex"
          flexDirection="column"
          minHeight={`calc(100dvh - ${navbarHeight}px)`}
          width="100%"
          mt={`${navbarHeight}px`}
          sx={{ backgroundColor: color ? color : 'white' }}
        >
          {children}
        </Box>
      </div>
    )
  }
}

export default Layout
